import React, { FC } from 'react';
import { FormInput } from '../merchants/FormInput';
import { InputType } from '../form/form-input-constants';
import { CUSTOM_KEY_FORM_FIELD, CUSTOM_KEY_FORM_FIELD_NAMES } from '../../constants/custom-key/custom-key-form';

interface Props {
	formik: any;
	isEditMode: boolean;
}

export const CustomKeyDetailsForm: FC<Props> = (props) => {
	const { formik, isEditMode } = props;
	return (
		<div className="col-xl-6">
			<FormInput
				formik={formik}
				fieldName={CUSTOM_KEY_FORM_FIELD.KEY_NAME}
				label={CUSTOM_KEY_FORM_FIELD_NAMES.KEY_NAME}
				placeholder={CUSTOM_KEY_FORM_FIELD_NAMES.KEY_NAME}
				inputType={InputType.Text}
				additionalClasses="col-md-4 col-xl-6"
				isEditMode={isEditMode}
				key={CUSTOM_KEY_FORM_FIELD.KEY_NAME}
			/>

			<FormInput
				formik={formik}
				fieldName={CUSTOM_KEY_FORM_FIELD.NOTE}
				label={CUSTOM_KEY_FORM_FIELD_NAMES.NOTE}
				placeholder={CUSTOM_KEY_FORM_FIELD_NAMES.NOTE}
				inputType={InputType.Description}
				additionalClasses="col-md-6 col-xl-11"
				isEditMode={isEditMode}
				key={CUSTOM_KEY_FORM_FIELD.NOTE}
			/>
		</div>
	);
};
